var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb3 pt2 md-py4 px2 md-px4",attrs:{"id":"menu-items"}},[_c('div',{staticClass:"menu-content",domProps:{"innerHTML":_vm._s(_vm.menu)}})])}
var staticRenderFns = []

export { render, staticRenderFns }